import InfoCircle from "../Reusable Elements/InfoCircle";
import InfoRectangle from "../Reusable Elements/InfoRectangle";

const ProjectLocation = () => {
    const landmarks = [
        { name: "Khayaban-e-Jinnah", distance: "1 minute" },
        { name: "The Punjab School", distance: "Walking distance" },
        { name: "University of Central Punjab", distance: "5 minutes" },
        { name: "Shaukat Khanum Hospital", distance: "7 minutes" },
        { name: "Ring Road", distance: "10 minutes" },
        { name: "WAPDA Town", distance: "10 minutes" },
        { name: "Emporium Mall", distance: "15 minutes" },
    ];

    const features = [
        { text: "LDA Approved Society" },
        { text: "Landscape Gated Community" },
        { text: "Underground Electricity Supply" },
        { text: "24/7 Security Surveillance" },
    ];

    return (
        <div className="bg-primary-blue flex flex-col items-center pt-10">
            <div className="text-primary-gold text-5xl font-extralight font-poppins text-center">
                Location
            </div>
            <div className="text-primary-white text-xl font-extralight font-poppins text-center sm:px-32 px-8 pt-10 mb-16">
                At Sultana Homes, what adds to the luxury is the location
                itself. Because when you live here, you have close proximity to
                the best that Lahore has to offer. Like the most happening
                malls, multiplexes, corporate offices, commercial
                establishments, schools, hospitals and more. A few minutes of
                driving and you’re there.
            </div>
            <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13619.02792801159!2d74.2491292!3d31.420821!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919010f9ae3e7ab%3A0xf1a118850632c7ba!2sSultana%20Homes!5e0!3m2!1sen!2s!4v1727387429729!5m2!1sen!2s"
                height="450"
                style={{ border: "0", width: "100vw", maxWidth: "600px" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="flex flex-wrap justify-center sm:gap-x-[160px] gap-y-20 pb-16 sm:px-9 gap-x-[200px] mt-20">
                {landmarks.map((landmark, index) => (
                    <InfoCircle
                        key={index}
                        heading={landmark.name}
                        text={landmark.distance}
                        variant={2}
                        color={"blue"}
                    />
                ))}
            </div>
            <div className="text-primary-gold text-5xl font-extralight font-poppins text-center pt-10">
                Features
            </div>
            <div className="flex flex-wrap justify-center sm:gap-x-[160px] gap-y-20 pb-16 sm:px-9 gap-x-[200px] mt-16">
                {features.map((feature, index) => (
                    <InfoRectangle key={index} text={feature.text} />
                ))}
            </div>
        </div>
    );
};

export default ProjectLocation;
